import { createAction } from '@reduxjs/toolkit';

export const APP_OPENED_FROM_EMAIL = 'notifications/app_opened_from_email';
export const EMAIL_CONFIRMED = 'notifications/email_confirmed';

export const AppOpenedFromEmailAction = createAction<string>(
	APP_OPENED_FROM_EMAIL
);

export const EmailConfirmedAction = createAction<string>(EMAIL_CONFIRMED);
